import { render, staticRenderFns } from "./PersonContractEdit.vue?vue&type=template&id=66b54d58&scoped=true&"
import script from "./PersonContractEdit.vue?vue&type=script&lang=js&"
export * from "./PersonContractEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b54d58",
  null
  
)

export default component.exports